<template>
    <div class="projects">
        <div class="title">
            <router-link :to="{ name: 'ProjectsCreate' }" v-if="role == 'consumer'"> 
                <IconComponent class="icon" icon="add" />
            </router-link>
        </div>

        <template v-if="assigned.length">
            <h3>Em curso</h3>
            <TableComponent :columns="getColumns(true)" :elements="assigned" :option="selectOption"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>

        <template v-if="unassigned.length">
            <h3>Novos</h3>
            <TableComponent :columns="getColumns(false)" :elements="unassigned" :option="selectOption"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>

        <template v-if="done.length">
            <h3>Finalizados</h3>
            <TableComponent :columns="getColumns(false)" :elements="done" :option="selectOption"
                :destination="(project) => ({ name: 'ProjectMessages', params: { id: project.id } })">
            </TableComponent>
        </template>
    </div>
</template>

<script>
import IconComponent from '@/components/Icons.vue'
import TableComponent from '../Table.vue';

export default {
    name:'ProjectsList',
    props: {
    },
    components: {
        IconComponent,
        TableComponent,
    },
    data() {
        return {
            columns: [
                // { text: this.$t('consumer'), attribute: 'consumerName', role: 'admin' },
                // { text: this.$t('consumer'), attribute: 'consumerName', role: 'worker' },
                { text: this.$t('name'), attribute: 'name' },
                { text: this.$t('service'), attribute: 'serviceName' },
                { attribute: 'state', role: 'worker' },
                { text: this.$t('worker'), attribute: 'workerName', role: 'admin' },
                { text: this.$t('worker'), attribute: 'workerName', role: 'consumer' },
                // { text: `Mensagens`, attribute: 'messagesLength' },
                { icon: "trash", method: this.delete, role: 'admin' },
                // { icon: "add", method: this.select, role: 'worker' },
                // { text: `Mensagens`, attribute: 'messagesLength' },
                // { text: `Mensagens`, attribute: 'messagesLength' },
            ],
            isAssignedSection: false,
        }
    },
    methods: {
        getColumns(hideAddIcon = false) {
            return this.columns.filter((column) => {
                const currentRole = !column.role || column.role === this.role
                const addIcon = !(hideAddIcon && column.icon === "add")
                return currentRole && addIcon
            });
        },
        delete(project) {
            this.$store.dispatch('projects/delete', project.id)
        },

        select(project) {
            this.$store.dispatch('projects/assignToSelf', project.id)
        },
    },

    computed: {
        assigned() {
            return this.$store.getters['projects/assigned']
        },

        done() {
            return this.$store.getters['projects/done']
        },

        consumers() {
            return this.$store.state.consumers.all
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
        service() {
            if (this.role != 'worker') {
                return null
            }
            if (!this.$store.state.users.userInfo) {
                return null
            }
            return this.$store.state.users.userInfo.service
        },
        services() {
            return this.$store.state.services.all
        },
        project(project) {
            return this.$store.getters["projects/id"](project.id)
        },
        projectWorker() {
            return this.$store.state.users.project
        },
        role() {
            return this.$store.state.users.role;
        },
        filterColumns() {
            return this.columns.filter((column) => !column.role || column.role == this.role)
        },
        selectOption() {
            if (this.role == 'worker') {
                return 'adicionar'
            } else {
                return 'apagar'
            }
        },
        unassigned() {
            return this.$store.getters['projects/unassigned']
        },
        workers() {
            return this.$store.state.workers.all
        },
    },

    watch: {
        role: {
            immediate: true,
            handler() {
                console.log(this.role)
                if (this.role == 'worker' && this.service == null) {
                    return
                }
                this.$store.dispatch('projects/getAll', this.role)
            },
        },
        service: {
            immediate: true,
            handler() {
                if (this.role == 'worker' && this.service == null) {
                    return
                }
                this.$store.dispatch('projects/getAll', this.role)
            },
        },
    },

    async mounted() {
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.projects {
    padding: 1.5rem 2rem;

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-h1 {
            margin-top: 0;
        }

        .icon {
            width: 20px;
            height: 20px;
            fill: var(--text-color);
        }
    }
}
</style>
